import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import Range from 'rc-slider/lib/Range';
import Media from 'react-media';
import { getBrowserFilter, hasFilter } from '../../redux/modules/browser/selectors';
import { selectDisctrictOptions } from '../../redux/modules/districts/selectors';
import {
  changeBrowserTerm as changeTerm,
  toggleBrowserType as toggleType,
  changeBrowserRange as changeRange,
  setBrowserDistrict as setDistrict,
  reset
} from '../../redux/actions';

import 'rc-slider/assets/index.css';
import './Filter.scss';


const TYPE_LABELS = {
  wall: 'Brandmūri',
  pale: 'Stendi krasta ielā',
//  overpass: 'Tiltu pārvadi',
};


class PriceRange extends PureComponent {
  constructor(props) {
    super(props);
    const { range, min, max } = this.props;
    this.state = {
      value: [min || range.min, max || range.max]
    }
  }

  onChange = value => {
    this.setState({value});
  };

  // Commit on release
  onAfterChange = value => {
    this.props.changeRange(value);
  };

  componentWillReceiveProps({min, max, range}) {
    // Restore has precedence
    if (min !== this.state.min || max !== this.state.max) {
      this.setState({value: [
        min || range.min,
        max || range.min
      ]});
    }
  }

  render() {
    return (
      <div className="form-group">
        <div className="row">
          <div className="col-12">
            <Range
              trackStyle={[{backgroundColor: '#9ec73d'}]}
              handleStyle={[
                {borderColor: '#9ec73d'},
                {borderColor: '#9ec73d'}
              ]}
              {...this.props.range}
              value={this.state.value}
              allowCross={false}
              onChange={this.onChange}
              onAfterChange={this.onAfterChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6 text-sm-left">
            € {this.state.value[0]}
          </div>
          <div className="col-6 text-sm-right">
            € {this.state.value[1]}
          </div>
        </div>
      </div>
    )
  }
}

const TypeNav = ({ types, toggleType }) => (
  <div className="form-group">
    <div className="btn-group d-flex">
      {Object.keys(types).map(key => {
        return (
          <button
            type="button"
            className={classNames("btn d-flex align-items-center col", key, { active: types[key] })}
            key={key}
            onClick={_ => toggleType(key)}
          >
            <i className={`icon ${key}`}/> {TYPE_LABELS[key]}
          </button>
        )}
      )}
    </div>
  </div>
)

const Filter = ({
  filter: {
    district,
    term,
    min,
    max,
    types,    
  },
  range,
  changeTerm,
  toggleType,
  changeRange,
  distirictOptions,
  setDistrict,
  hasFilter,
  reset
}) => (
  <form id="item-filter">
    <div className="row">
      <div className="col-6">
        <div className="form-group search-group">
          <input
            type="text"
            className="form-control form-control-search"
            placeholder="Meklēt reklāmas objektu"
            value={term}
            onChange={(e) => changeTerm(e.target.value) }
          />
          <i className="fa fa-search" />
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <select className="form-control" value={district} onChange={e => setDistrict(e.target.value)}>
            <option value="" style={{color: "gray"}}>Rajons</option>
            {distirictOptions.map(({id, label}) =>
              <option key={id} value={id}>{label}</option>
            )}
          </select>
        </div>
      </div>
    </div>
    <TypeNav types={types} toggleType={toggleType} />
    { range && <Media query="(min-width: 576px)" render={() => 
      (<PriceRange
        range={range}
        changeRange={changeRange}
        min={min}
        max={max}
      />)}/>}
      { hasFilter && (
        <button
          type="button"
          onClick={reset}
          className="btn btn-link reset-link"
        >
          <i className="fa fa-close"/> Atcelt filtru
        </button>
      )}
  </form>
);

Filter.propTypes = {
  range: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired
  }),
  filter: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    term: PropTypes.string.isRequired,
    district: PropTypes.string.isRequired,
    types: PropTypes.object.isRequired,
  }).isRequired,
  changeTerm: PropTypes.func.isRequired,
  toggleType: PropTypes.func.isRequired,
  changeRange: PropTypes.func.isRequired,
  setDistrict: PropTypes.func.isRequired,
  hasFilter: PropTypes.bool.isRequired,
  distirictOptions: PropTypes.array.isRequired,
  reset: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
  filter: getBrowserFilter(state, props),
  range: state.browser.range,
  distirictOptions: selectDisctrictOptions(state),
  hasFilter: hasFilter(state, props)
});

export default connect(mapStateToProps, {
  changeTerm,
  toggleType,
  changeRange,
  setDistrict,
  reset
})(Filter);


// WEBPACK FOOTER //
// ./src/scenes/FilterList/Filter.js